.wrapper {
  position: relative;

  /* fade in: render with .fade then remove.
   * fade out: add .fade then wait for transition end.
   */
  opacity: 1;
  transition: opacity 200ms ease-in-out;
  &.fade {
    opacity: 0;
  }
}

.overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  user-select: none;
  pointer-events: none;
  cursor: wait;
  z-index: 100;

  &.fullscreen {
    position: fixed;
    .spinner {
      width: 80px;
    }
  }

  &.dim::before {
    content: ' ';
    position: absolute;
    inset: 0;
    background-color: black;
    opacity: 0.1;
  }

  .spinner {
    width: 50px;
    max-width: 90%;
  }
}

.inline {
  display: inline;

  .spinner {
    display: inline;
    height: 0.9em;
    margin-bottom: -0.05em;
    width: auto;
  }
}

.spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
